<template>
    <div>
        <b-card class="card-news-form" header-tag="header" footer-tag="footer">
        <alert-success :redirectName="'101zones-home'" :show="successMessage != ''"> {{ successMessage }} </alert-success>
        <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
        <!-- for loading page -->
        <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
        <div slot="header">
        <i class="fa fa-list-ul" aria-hidden="true"></i>
            Zone Form
        <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
            <small class="text-muted">docs</small>
            </a>
        </div>
        </div>
        <div>

          <b-row>
            <b-col sm="12">
               <!-- Name -->
              <b-form-group>
                <label>Name</label>
                <b-input-group>
                    <b-input :state="feedback(fieldErrors.name)" v-model="form.name" placeholder="please enter zone name"></b-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            Back
          </b-button>
          <b-button :disabled="!isActive" @click="save" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
          <b-button v-show="false" :disabled="!isActive" v-b-modal.confirmDelete v-if="$route.params.id" type="reset" size="sm" variant="danger">
            <i class="fa fa-ban"></i>
            Delete
          </b-button>
          <alert-confirm
            :id="'confirmDelete'"
            @confirm="confirmDelete">
            confirm to delete ?
          </alert-confirm>
        </div>
    </b-card>
    </div>
</template>

<script>
import AlertSuccess from '../../components/alert/AlertSuccess';
import AlertConfirm from '../../components/alert/AlertConfirm';
import Loading from '../../components/Loading';
import { OptionList } from '../../models/option-list';

export default {
  data () {
    return {
      isLoading: false,
      successMessage: '',
      errorMessage: '',
      isActive: true,
      form: {
        name: ''
      },
      fieldErrors: {},
      optionList: new OptionList(this.axios)
    };
  },
  methods: {
    confirmDelete () {
      this.axios.delete(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/base/zones/' + this.$route.params.id)
        .then(response => {
          this.successMessage = 'delete zone finish!';
        })
        .catch(error => {
          console.log(error.response);
          this.isLoading = false;
          this.isActive = true;
          this.handleError(error);
        });
    },
    save () {
      this.setDefault();
      const id = this.$route.params.id;
      this.isLoading = true;
      this.isActive = false;
      const formData = new FormData();
      formData.append('name', this.form.name);

      if (id) { // update
        this.axios.patch(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/base/zones/' + id, formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'update zone finish!';
          })
          .catch(error => {
            this.isLoading = false;
            this.isActive = true;
            this.handleError(error);
          });
      } else { // create
        this.axios.post(process.env.VUE_APP_URL_UNIVERSAL_API + '/mqdc/base/zones', formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'create zone finish!';
          })
          .catch(error => {
            this.isLoading = false;
            this.isActive = true;
            this.handleError(error);
          });
      }
    },
    getData () {
      this.setDefault();
      const id = this.$route.params.id;
      if (id) {
        this.isLoading = true;
        this.optionList.loadZones()
          .then(response => {
            const zone = response.find(data => id === data.code);
            if (!zone) {
              throw new Error('cannot get data');
            }
            this.form.name = zone.label;
            this.isBusy = false;
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    handleError (error) {
      this.fieldErrors = {};
      this.errorMessage = error.message;
      if (error.response) {
        this.errorMessage = error.response.data.message;
        const data = error.response.data.data;
        this.setFieldErrors(data);
      }
      this.isLoading = false;
    },
    setFieldErrors (fields) {
      if (fields) {
        for (const field of fields) {
          this.fieldErrors[field.param] = { message: field.msg, isCorrect: false };
        }
      }
    },
    setDefault () {
      this.form = {
        name: ''
      };
      this.errorMessage = '';
      this.fieldErrors = {};
    }
  },
  components: {
    AlertSuccess,
    AlertConfirm,
    'app-loading': Loading
  },
  computed: {
    feedback () {
      return data => {
        if (!data) {
          return null;
        } else {
          return data.isCorrect;
        }
      };
    }
  },
  watch: {
    '$route' (to, from) {
      this.getData();
    }
  },
  mounted () {
    this.getData();
  }
};
</script>
